// A line Pluto says without a model call (the guest introduction, the
// project greeting): the same look as an answer (the Pluto label above the
// text), with optional quick-reply chips under it. Never stored, never
// counted against any quota.
import type { ReactNode } from "react";
import { Glyph } from "../ui/icons";

export function PlutoSay({ children, chips, className = "" }: { children: ReactNode; chips?: ReactNode; className?: string }) {
  return (
    <li className={`msg guest-say ${className}`.trim()} data-role="assistant">
      <div className="msg-source" data-source="faq">
        <span className="badge msg-badge">
          <Glyph name="magicStar" size={16} />
          <span>Pluto</span>
        </span>
      </div>
      <div className="msg-md">
        <p>{children}</p>
      </div>
      {chips}
    </li>
  );
}

// The greeting a project home showed, remembered for the conversation its
// first message opened (this page session only), so the new thread starts
// with it too. Not stored anywhere else.
const greetings = new Map<string, string>();

export function rememberGreeting(conversationId: string, text: string): void {
  greetings.set(conversationId, text);
}

export function greetingFor(conversationId: string | null | undefined): string | null {
  return conversationId ? (greetings.get(conversationId) ?? null) : null;
}
